import React from 'react';

const SectionTitle = ({ 
    title, 
    subtitle, 
    description, 
    theme = 'light', // 'light' or 'dark'
    className = '',
    variant = 'default' // 'default' or 'underlined'
}) => {
    const isDark = theme === 'dark';
    const isYellowBg = className.includes('bg-yellow-500');
    
    const hasMarginBottom = (classes) => {
        const marginClasses = ['mb-', 'margin-bottom'];
        return marginClasses.some(marginClass => classes.includes(marginClass));
    };

    const containerClasses = `max-w-4xl mx-auto text-center ${hasMarginBottom(className) ? '' : 'mb-16'} ${className}`;
    
    return (
        <div className={containerClasses}>
            {subtitle && (
                <div className="inline-flex items-center space-x-2 mb-6">
                    <div className={`h-0.5 w-8 ${isDark ? 'bg-white' : 'bg-yellow-500'}`}></div>
                    <span className={`${isDark ? 'text-white' : 'text-yellow-500'} font-medium tracking-wider uppercase text-sm`}>
                        {subtitle}
                    </span>
                    <div className={`h-0.5 w-8 ${isDark ? 'bg-white' : 'bg-yellow-500'}`}></div>
                </div>
            )}
            <h2 className={`text-4xl md:text-5xl font-bold mb-6 ${isDark ? 'text-white' : 'text-gray-900'} ${variant === 'underlined' ? 'relative inline-block' : ''}`}>
                {title}
                {variant === 'underlined' && (
                    <div className={`absolute -bottom-2 left-0 w-full h-1 ${isDark ? 'bg-white' : 'bg-yellow-500'} transform scale-x-75`}></div>
                )}
            </h2>
            {description && (
                <p className={`text-lg ${isDark ? 'text-gray-200' : 'text-gray-600'}`}>
                    {description}
                </p>
            )}
        </div>
    );
};

export default SectionTitle; 